export default "__VITE_ASSET__BXj8j6vv__"